import React, { memo, useEffect } from "react";
import "./HawkeyeTopBar.scss";
import HawkeyeSearch from "../HawkeyeSearch/HawkeyeSearch";
import HawkeyeUser from "../HawkeyeUser/HawkeyeUser";
import Icon from "../Icons/Icon";

function HawkeyeTopBar(props) {
  const { logo, appSettings, onClickExpandCollapseNavBar, collapse } = props;

  return (
    <div className="hawkeye-top-bar">
      {appSettings && appSettings.showHamburgerIcon && (
        <div
          className="hawkeye-logo-container menu"
          onClick={() => onClickExpandCollapseNavBar(appSettings, collapse)}
        >
          <img className="hawkeye-left-logo" src={"images/Menu.png"} />
        </div>
      )}
      <div className="hawkeye-logo-container">
        <img className="hawkeye-left-logo" src={logo} />
      </div>
      {props.pages && props.pages.length > 0 && (
        <HawkeyeSearch
          dashboard={props.dashboard}
          pages={props.pages}
          currentPageIndex={props.currentPageIndex}
          onSelection={props.onSelection}
          appName={props.appName}
          appID={props.appID}
          componentID={props.componentID}
          appSettings={appSettings}
        />
      )}
      <HawkeyeUser
        userInfo={props.userInfo}
        logout={props.logout}
        isLogoutDisabled={props.isLogoutDisabled}
      />
    </div>
  );
}
export default memo(HawkeyeTopBar);
